// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph-module__paragraph___1m_-L"};